var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "div" }, [
    _c("div", { staticClass: "div-top" }, [
      _c(
        "div",
        [
          _c("span", { staticClass: "label" }, [_vm._v("时间选项:")]),
          _c(
            "el-radio-group",
            {
              on: { change: _vm.timeTypeChange },
              model: {
                value: _vm.searchData.TimeType,
                callback: function ($$v) {
                  _vm.$set(_vm.searchData, "TimeType", $$v)
                },
                expression: "searchData.TimeType",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: "YearMonth" } }, [
                _vm._v("年月"),
              ]),
              _c("el-radio-button", { attrs: { label: "Year" } }, [
                _vm._v("年份"),
              ]),
            ],
            1
          ),
          _vm.searchData.TimeType === "Year"
            ? _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("选择年份:")]),
                  _c("el-date-picker", {
                    staticStyle: { width: "150px", "text-align": "center" },
                    attrs: {
                      type: "year",
                      "picker-options": _vm.startYearOptions,
                      placeholder: "选择年份",
                      "value-format": "yyyy",
                      clearable: false,
                    },
                    on: { change: _vm.getDataList },
                    model: {
                      value: _vm.searchData.StartTimeYear,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchData, "StartTimeYear", $$v)
                      },
                      expression: "searchData.StartTimeYear",
                    },
                  }),
                  _c("span", { staticClass: "separator" }, [_vm._v("至")]),
                  _c("el-date-picker", {
                    staticStyle: { width: "150px", "text-align": "center" },
                    attrs: {
                      type: "year",
                      placeholder: "结束年份",
                      "picker-options": _vm.endYearOptions,
                      "value-format": "yyyy",
                      clearable: false,
                    },
                    on: { change: _vm.getDataList },
                    model: {
                      value: _vm.searchData.EndTimeYear,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchData, "EndTimeYear", $$v)
                      },
                      expression: "searchData.EndTimeYear",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.searchData.TimeType === "YearMonth"
            ? _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("选择年月:")]),
                  _c("el-date-picker", {
                    attrs: {
                      "picker-options": _vm.monthRangeOptions,
                      type: "monthrange",
                      clearable: false,
                      "range-separator": "至",
                      "value-format": "yyyyMM",
                      "start-placeholder": "开始月份",
                      "end-placeholder": "结束月份",
                    },
                    on: { change: _vm.getDataList },
                    model: {
                      value: _vm.searchData.searchYear,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchData, "searchYear", $$v)
                      },
                      expression: "searchData.searchYear",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.buildingLoading,
              expression: "buildingLoading",
            },
          ],
          staticClass: "search-item",
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v("选择楼栋分类:")]),
          _c(
            "el-checkbox-group",
            {
              on: { change: _vm.BuildingsListChange },
              model: {
                value: _vm.searchData.Buildings,
                callback: function ($$v) {
                  _vm.$set(_vm.searchData, "Buildings", $$v)
                },
                expression: "searchData.Buildings",
              },
            },
            _vm._l(_vm.BuildingsList, function (item) {
              return _c(
                "el-checkbox",
                {
                  key: item.Id,
                  attrs: { label: item.Id, disabled: item.disabled },
                },
                [_vm._v(_vm._s(item.Name))]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.deviceTypeLoading,
              expression: "deviceTypeLoading",
            },
          ],
          staticClass: "search-item",
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v("选择设备分类:")]),
          _c(
            "el-checkbox-group",
            {
              on: { change: _vm.DeviceTypesListChange },
              model: {
                value: _vm.searchData.DeviceTypes,
                callback: function ($$v) {
                  _vm.$set(_vm.searchData, "DeviceTypes", $$v)
                },
                expression: "searchData.DeviceTypes",
              },
            },
            _vm._l(_vm.DeviceTypesList, function (item) {
              return _c(
                "el-checkbox",
                {
                  key: item.Id,
                  attrs: { label: item.Id, disabled: item.disabled },
                },
                [_vm._v(_vm._s(item.DicName))]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "dom-card",
        staticStyle: { "margin-top": "10px" },
      },
      [
        _c("div", { staticClass: "dom-card-title" }, [_vm._v("工单情况分析")]),
        _c(
          "div",
          { staticClass: "df aic w100", staticStyle: { "margin-top": "10px" } },
          [
            _c(
              "div",
              { staticClass: "df", staticStyle: { width: "70%", gap: "5px" } },
              _vm._l(_vm.workOrderList?.totalpiechart || [], function (item) {
                return _c("EchartsDom", {
                  key: item.name,
                  style: "border-right: 1px solid #ccc",
                  attrs: {
                    type: "pie",
                    data: item.value,
                    title: item.name,
                    showLegend: false,
                    labelOption: {
                      formatter: (params) => {
                        return params.value && params.value !== 0
                          ? `${params.name}:  ${params.percent}%`
                          : ""
                      },
                    },
                    width: "25%",
                    height: "200px",
                  },
                })
              }),
              1
            ),
            _c("div", { staticStyle: { width: "30%", "min-width": "400px" } }, [
              _c(
                "div",
                { staticClass: "class-table" },
                [
                  _vm.workOrderList?.slist?.length > 0
                    ? _c("div", { staticClass: "class-tableItem" }, [
                        _c("div", { staticClass: "class-tableItem-title" }, [
                          _vm._v("状态"),
                        ]),
                        _vm._m(0),
                        _vm._m(1),
                        _vm._m(2),
                        _vm._m(3),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.workOrderList.slist || [], function (item) {
                    return _c(
                      "div",
                      { key: item.name, staticClass: "class-tableItem" },
                      [
                        _c("div", { staticClass: "class-tableItem-title" }, [
                          _vm._v(" " + _vm._s(item.name) + " "),
                        ]),
                        _c("div", { staticClass: "class-tableItem-content" }, [
                          _c(
                            "div",
                            { staticClass: "class-tableItem-content-item" },
                            [_vm._v(" " + _vm._s(item.list.xjNums || 0) + " ")]
                          ),
                        ]),
                        _c("div", { staticClass: "class-tableItem-content" }, [
                          _c(
                            "div",
                            { staticClass: "class-tableItem-content-item" },
                            [_vm._v(" " + _vm._s(item.list.bjNums || 0) + " ")]
                          ),
                        ]),
                        _c("div", { staticClass: "class-tableItem-content" }, [
                          _c(
                            "div",
                            { staticClass: "class-tableItem-content-item" },
                            [_vm._v(" " + _vm._s(item.list.wxNums || 0) + " ")]
                          ),
                        ]),
                        _c("div", { staticClass: "class-tableItem-content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "class-tableItem-content-item",
                              staticStyle: {
                                "font-weight": "bold",
                                "font-size": "14px",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.list.Nums || 0) + " ")]
                          ),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]
        ),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "dom-card",
        staticStyle: { "margin-top": "10px" },
      },
      [
        _vm._m(4),
        _c(
          "div",
          { staticClass: "Table-List cpad" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "50%", "min-height": "240px" },
                attrs: {
                  data: _vm.workOrderList.blist,
                  "header-row-class-name": "table-tit",
                  "row-class-name": "table-row",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "TypeName", align: "center", label: "楼栋" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "state", align: "center", label: "状态" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(row?.state || [], function (item, index) {
                          return _c(
                            "div",
                            {
                              key: item,
                              class: [
                                "table-content",
                                index === row?.state?.length - 1 ? "" : "bot1",
                              ],
                              staticStyle: { "justify-content": "center" },
                            },
                            [_vm._v(" " + _vm._s(item) + " ")]
                          )
                        })
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "xjNums", align: "right", label: "巡检" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(
                          row?.xjNums || [],
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: JSON.stringify(item),
                                class: [
                                  "table-content",
                                  index === row?.xjNums?.length - 1
                                    ? ""
                                    : "bot1",
                                ],
                              },
                              [_vm._v(" " + _vm._s(item.value) + " ")]
                            )
                          }
                        )
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "bjNums", align: "right", label: "保养" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(
                          row?.bjNums || [],
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: JSON.stringify(item),
                                class: [
                                  "table-content",
                                  index === row?.bjNums?.length - 1
                                    ? ""
                                    : "bot1",
                                ],
                              },
                              [_vm._v(" " + _vm._s(item.value) + " ")]
                            )
                          }
                        )
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "wxNums", align: "right", label: "维修" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(
                          row?.wxNums || [],
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: JSON.stringify(item),
                                class: [
                                  "table-content",
                                  index === row?.wxNums?.length - 1
                                    ? ""
                                    : "bot1",
                                ],
                              },
                              [_vm._v(" " + _vm._s(item.value) + " ")]
                            )
                          }
                        )
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "Nums", align: "right", label: "总数" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(row?.Nums || [], function (item, index) {
                          return _c(
                            "div",
                            {
                              key: JSON.stringify(item),
                              class: [
                                "table-content",
                                index === row?.Nums?.length - 1 ? "" : "bot1",
                              ],
                            },
                            [_vm._v(" " + _vm._s(item.value) + " ")]
                          )
                        })
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "Nums",
                    align: "center",
                    label: "统计",
                    width: "300",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("EchartsDom", {
                            attrs: {
                              type: "bar2",
                              data: row?.echartsData || [],
                              width: "100%",
                              height: "150px",
                              showLegend: false,
                              grid: {
                                top: 30,
                                left: 60,
                                bottom: 30,
                                right: 10,
                              },
                              barMaxWidth: "20px",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("el-divider", {
              staticClass: "divider",
              attrs: { direction: "vertical" },
            }),
            _c(
              "el-table",
              {
                staticStyle: { width: "50%", "min-height": "240px" },
                attrs: {
                  data: _vm.workOrderList.tlist,
                  "header-row-class-name": "table-tit",
                  "row-class-name": "table-row",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "TypeName",
                    align: "center",
                    label: "设备分类",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "state", align: "center", label: "状态" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(row?.state || [], function (item, index) {
                          return _c(
                            "div",
                            {
                              key: item,
                              class: [
                                "table-content",
                                index === row?.state?.length - 1 ? "" : "bot1",
                              ],
                              staticStyle: { "justify-content": "center" },
                            },
                            [_vm._v(" " + _vm._s(item) + " ")]
                          )
                        })
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "xjNums", align: "right", label: "巡检" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(
                          row?.xjNums || [],
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: JSON.stringify(item),
                                class: [
                                  "table-content",
                                  index === row?.xjNums?.length - 1
                                    ? ""
                                    : "bot1",
                                ],
                              },
                              [_vm._v(" " + _vm._s(item.value) + " ")]
                            )
                          }
                        )
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "bjNums", align: "right", label: "保养" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(
                          row?.bjNums || [],
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: JSON.stringify(item),
                                class: [
                                  "table-content",
                                  index === row?.bjNums?.length - 1
                                    ? ""
                                    : "bot1",
                                ],
                              },
                              [_vm._v(" " + _vm._s(item.value) + " ")]
                            )
                          }
                        )
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "wxNums", align: "right", label: "维修" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(
                          row?.wxNums || [],
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: JSON.stringify(item),
                                class: [
                                  "table-content",
                                  index === row?.wxNums?.length - 1
                                    ? ""
                                    : "bot1",
                                ],
                              },
                              [_vm._v(" " + _vm._s(item.value) + " ")]
                            )
                          }
                        )
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "Nums", align: "right", label: "总数" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(row?.Nums || [], function (item, index) {
                          return _c(
                            "div",
                            {
                              key: JSON.stringify(item),
                              class: [
                                "table-content",
                                index === row?.Nums?.length - 1 ? "" : "bot1",
                              ],
                            },
                            [_vm._v(" " + _vm._s(item.value) + " ")]
                          )
                        })
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "Nums",
                    align: "center",
                    label: "统计",
                    width: "300",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("EchartsDom", {
                            attrs: {
                              type: "bar2",
                              data: row?.echartsData || [],
                              width: "100%",
                              height: "150px",
                              showLegend: false,
                              grid: {
                                top: 30,
                                left: 60,
                                bottom: 30,
                                right: 10,
                              },
                              barMaxWidth: "20px",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.workOrderTimeLoading || _vm.workOrderTimeLoading2,
            expression: "workOrderTimeLoading || workOrderTimeLoading2",
          },
        ],
        staticClass: "dom-card",
        staticStyle: { "margin-top": "10px" },
      },
      [
        _vm._m(5),
        _c(
          "div",
          { staticClass: "Table-List" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.workOrderTimeLoading,
                    expression: "workOrderTimeLoading",
                  },
                ],
                staticStyle: { width: "50%", "min-height": "240px" },
                attrs: { data: _vm.workOrderTimeList },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "TypeName", align: "center", label: "楼栋" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "xjNums",
                    align: "right",
                    label: "巡检工单（小时）",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "bjNums",
                    align: "right",
                    label: "保养工单（小时）",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "wxNums",
                    align: "right",
                    label: "维修工单（小时）",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "Nums",
                    align: "right",
                    label: "平均用时（小时）",
                  },
                }),
              ],
              1
            ),
            _c("el-divider", {
              staticClass: "divider",
              attrs: { direction: "vertical" },
            }),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.workOrderTimeLoading2,
                    expression: "workOrderTimeLoading2",
                  },
                ],
                staticStyle: { width: "50%", "min-height": "240px" },
                attrs: { data: _vm.workOrderTimeList2 },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "TypeName",
                    align: "center",
                    label: "设备分类",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "xjNums",
                    align: "right",
                    label: "巡检工单（小时）",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "bjNums",
                    align: "right",
                    label: "保养工单（小时）",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "wxNums",
                    align: "right",
                    label: "维修工单（小时）",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "Nums",
                    align: "right",
                    label: "平均用时（小时）",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.workOrderAreaLoading || _vm.workOrderDeviceLoading,
            expression: "workOrderAreaLoading || workOrderDeviceLoading",
          },
        ],
        staticClass: "dom-card",
        staticStyle: { "margin-top": "10px" },
      },
      [
        _vm._m(6),
        _c(
          "div",
          { staticClass: "Table-List" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.workOrderAreaLoading,
                    expression: "workOrderAreaLoading",
                  },
                ],
                staticStyle: { width: "50%", "min-height": "240px" },
                attrs: { data: _vm.workOrderAreaList },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "TypeName", align: "center", label: "楼栋" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "Nums", align: "right", label: "面积" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "xjNums", align: "right", label: "巡检负荷" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "bjNums", align: "right", label: "保养负荷" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "wxNums", align: "right", label: "维修负荷" },
                }),
              ],
              1
            ),
            _c("el-divider", {
              staticClass: "divider",
              attrs: { direction: "vertical" },
            }),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.workOrderDeviceLoading,
                    expression: "workOrderDeviceLoading",
                  },
                ],
                staticStyle: { width: "50%", "min-height": "240px" },
                attrs: { data: _vm.workOrderDeviceList },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "TypeName",
                    align: "center",
                    label: "设备分类",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "Nums", align: "right", label: "设备量" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "xjNums", align: "right", label: "巡检负荷" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "bjNums", align: "right", label: "保养负荷" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "wxNums", align: "right", label: "维修负荷" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
    _c("div", { staticStyle: { height: "20px" } }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "class-tableItem-content" }, [
      _c("div", { staticClass: "class-tableItem-content-item" }, [
        _vm._v("完成"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "class-tableItem-content" }, [
      _c("div", { staticClass: "class-tableItem-content-item" }, [
        _vm._v("进行中"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "class-tableItem-content" }, [
      _c("div", { staticClass: "class-tableItem-content-item" }, [
        _vm._v("未分配"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "class-tableItem-content" }, [
      _c(
        "div",
        {
          staticClass: "class-tableItem-content-item",
          staticStyle: { "font-weight": "bold", "font-size": "14px" },
        },
        [_vm._v(" 总量 ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dom-card-title df aic jub" }, [
      _c("div", { staticStyle: { width: "50%" } }, [
        _c("span", [_vm._v("A1.按楼栋工单分布")]),
        _c("span", { staticClass: "hint-text" }),
      ]),
      _c("div", { staticStyle: { width: "50%", "padding-left": "20px" } }, [
        _c("span", [_vm._v("B1.按专业设备工单分布")]),
        _c("span", { staticClass: "hint-text" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dom-card-title df aic jub" }, [
      _c("div", { staticClass: "df aic jub", staticStyle: { width: "50%" } }, [
        _c("span", [_vm._v("A2.按楼栋工单耗时统计")]),
        _c("span", { staticClass: "hint-text" }, [
          _vm._v(" （从派单到完工用时） "),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "df aic jub",
          staticStyle: { width: "50%", "padding-left": "20px" },
        },
        [
          _c("span", [_vm._v("B2.按专业设备工单耗时统计")]),
          _c("span", { staticClass: "hint-text" }, [
            _vm._v(" （从派单到完工用时） "),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dom-card-title df aic jub" }, [
      _c("div", { staticClass: "df aic jub", staticStyle: { width: "50%" } }, [
        _c("span", [_vm._v("A3.按楼栋面积工作负荷密度统计")]),
        _c("span", { staticClass: "hint-text" }, [_vm._v(" （次数/每平米） ")]),
      ]),
      _c(
        "div",
        {
          staticClass: "df aic jub",
          staticStyle: { width: "50%", "padding-left": "20px" },
        },
        [
          _c("span", [_vm._v("B3.按专业设备工作负荷密度统计")]),
          _c("span", { staticClass: "hint-text" }, [
            _vm._v(" （次数/设备量） "),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }